import TextCell from "@visiblethread/react-components/dist/components/Table/cells/TextCell";
import PropTypes from "prop-types";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { ReactComponent as Arrow } from "icons/dictionary/arrow-right-encircled.svg";
import { useDispatch } from "react-redux";
import { setRegexPanel } from "slices/settings/slices/acronymIgnoreSlice";

const IgnoreTerm = ({
  ignoreListItem,
  index,
  error,
  editMode,
  isSelected,
  handleCellChange,
  onEditorClose,
}) => {
  const dispatch = useDispatch();

  const handleNameChange = (updatedCell) => {
    handleCellChange(
      <IgnoreTerm
        index={index}
        ignoreListItem={{ ...ignoreListItem, term: updatedCell.props.text }}
        isSelected={isSelected}
        editMode={editMode}
        error={error}
        handleCellChange={handleCellChange}
        onEditorClose={onEditorClose}
      />
    );
  };

  const handleEditClick = () => {
    dispatch(setRegexPanel({ showRegex: true, ignoreListItem }));
  };

  return (
    <div className="term_name" data-testid="term-name">
      <TextCell
        text={ignoreListItem.term}
        handleCellChange={handleNameChange}
        isSelected={isSelected}
        disabled={editMode && ignoreListItem.regex}
        viewOnly={!editMode}
        error={error}
        editOnSelect={ignoreListItem.newlyCreated}
        onEditorClose={ignoreListItem.newlyCreated ? onEditorClose : undefined}
        ariaLabel="Term"
      />

      {editMode && ignoreListItem.regex && (
        <span className="term_name__right">
          <Button
            content={
              <div className="term_name__right__edit_button">
                <span>Edit</span>
                <Arrow role="img" aria-label="arrow" />
              </div>
            }
            variant={buttonVariants.borderless}
            onClick={handleEditClick}
          />
        </span>
      )}
    </div>
  );
};

export default IgnoreTerm;

IgnoreTerm.defaultProps = {
  editMode: false,
  isSelected: false,
};

IgnoreTerm.propTypes = {
  ignoreListItem: PropTypes.shape({
    term: PropTypes.string,
    regex: PropTypes.bool,
    newlyCreated: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  error: PropTypes.string,
  editMode: PropTypes.bool,
  isSelected: PropTypes.bool,
  handleCellChange: PropTypes.func,
  onEditorClose: PropTypes.func,
};
